import { BASE_URL_SETTING } from '~/constants/routes/settings/routes.constants'
import type { Route } from '~/interfaces/routes.interfaces'

const base = `${BASE_URL_SETTING}/financial-index`

export const SETTINGS_FINANCIAL_INDEX: Route = {
  path: base
}

export const SETTINGS_FINANCIAL_INDEX_CREATE: Route = {
  path: `${base}/create`
}

export const SETTINGS_FINANCIAL_INDEX_EDIT: Route = {
  path: `${base}/{id}`
}
